export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
        <div className="max-w-[650px] mx-auto text-center">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Ready to Access Hipobuy Sheet?
          </h2>
          <p className="text-base text-foreground-600 font-light mb-10 max-w-md mx-auto">
            Start exploring organized product spreadsheets today. Thousands of curated items across 14 categories are waiting for you on the main platform.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200 flex items-center justify-center gap-2"
            >
              Hipobuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-primary-500 text-primary-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-50 transition-colors duration-200 flex items-center justify-center gap-2"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <p className="text-xs text-foreground-400 mt-3">External links open kaspreadsheet.com in a new tab</p>
        </div>
      </div>

      <div className="mt-16 flex gap-0 overflow-hidden">
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20ceramic%20vase%20with%20dried%20pampas%20grass%20and%20a%20single%20art%20book%20on%20a%20light%20travertine%20side%20table%2C%20architectural%20interior%20corner%20with%20soft%20shadows%2C%20warm%20morning%20light%2C%20serene%20sophisticated%20atmosphere%2C%20cream%20and%20sand%20tones%2C%20luxury%20home%20aesthetic%2C%20calm%20curated%20composition&width=560&height=400&seq=cta-banner-1-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20leather%20tote%20bag%20with%20silk%20scarf%20tied%20on%20handle%2C%20resting%20on%20a%20marble%20bench%20in%20a%20sunlit%20conservatory%2C%20lush%20green%20plants%20in%20background%20blur%2C%20soft%20natural%20light%20filtering%20through%20glass%2C%20luxury%20lifestyle%20photography%2C%20warm%20ivory%20and%20sage%20tones%2C%20elegant%20aspirational%20mood&width=560&height=400&seq=cta-banner-2-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Artisan%20ceramic%20coffee%20mug%20beside%20an%20open%20notebook%20with%20handwritten%20notes%20and%20a%20fountain%20pen%2C%20on%20a%20rustic%20wooden%20table%20near%20a%20window%2C%20soft%20diffused%20daylight%2C%20cozy%20creative%20workspace%2C%20warm%20caramel%20and%20cream%20tones%2C%20intentional%20living%20aesthetic%2C%20peaceful%20morning%20ritual%20composition&width=560&height=400&seq=cta-banner-3-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Two%20pairs%20of%20stylish%20sunglasses%20on%20a%20woven%20rattan%20tray%20with%20a%20small%20tropical%20leaf%2C%20vacation%20mood%20on%20a%20light%20sandy%20surface%2C%20bright%20but%20soft%20natural%20light%2C%20warm%20golden%20and%20terracotta%20tones%2C%20resort%20lifestyle%20aesthetic%2C%20relaxed%20luxury%20composition%2C%20travel%20accessories%20photography&width=560&height=400&seq=cta-banner-4-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Handmade%20wool%20throw%20blanket%20draped%20over%20a%20mid%20century%20modern%20armchair%2C%20warm%20reading%20nook%20with%20a%20floor%20lamp%20casting%20soft%20golden%20light%2C%20hygge%20atmosphere%2C%20cozy%20texture%20rich%20composition%2C%20warm%20oatmeal%20and%20wheat%20tones%2C%20scandinavian%20interior%20aesthetic%2C%20peaceful%20home%20sanctuary%20mood&width=560&height=400&seq=cta-banner-5-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20sneaker%20care%20kit%20with%20wooden%20shoe%20trees%2C%20horsehair%20brush%2C%20and%20leather%20conditioner%20on%20a%20light%20marble%20surface%2C%20meticulous%20arrangement%2C%20soft%20directional%20lighting%2C%20luxury%20grooming%20aesthetic%2C%20warm%20cognac%20and%20cream%20tones%2C%20refined%20gentleman%20details%2C%20organized%20precision%20composition&width=560&height=400&seq=cta-banner-6-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Stack%20of%20lifestyle%20magazines%20and%20a%20steaming%20cup%20of%20matcha%20tea%20on%20a%20light%20oak%20coffee%20table%2C%20soft%20morning%20sunlight%20creating%20gentle%20shadows%2C%20slow%20living%20aesthetic%2C%20warm%20sage%20and%20cream%20palette%2C%20modern%20minimalist%20interior%2C%20peaceful%20weekend%20morning%20composition&width=560&height=400&seq=cta-banner-7-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-[280px] h-[200px] rounded-2xl overflow-hidden -mx-3 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20travel%20essentials%20including%20a%20passport%20holder%2C%20compact%20camera%2C%20vintage%20map%2C%20and%20leather%20keychain%20on%20a%20textured%20linen%20surface%2C%20wanderlust%20theme%2C%20warm%20afternoon%20light%2C%20adventure%20mood%2C%20earthy%20terracotta%20and%20sand%20tones%2C%20curated%20traveler%20aesthetic%2C%20story%20telling%20composition&width=560&height=400&seq=cta-banner-8-v3&orientation=landscape"
            alt="Hipobuy Spreadsheet product showcase"
            title="Hipobuy Spreadsheet - Product Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}